const funcion14 = {
    titulo: `Función: funciones recursivas`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Una función recursiva es una función que se llama a sí misma.
El primer ejemplo a plantear se trata de una función recursiva pero se genera un error por el intento de infinitas llamadas recursivas.`,
        programa: `function funcionRecursiva(valor) {
  funcionRecursiva(valor)
}
    
funcionRecursiva(5)`,
        solucion: ""
      }, {
        codigo: 2,
        descripcion: `Una función recursiva siempre dispondrá de una condición de corte, generalmente con un if que se verifica falso con cierta condición y se detienen las llamadas recursivas.`,
        programa: `const arreglo = []

function generarNumeros1a10(valor) {
  if (valor <= 10) {
    arreglo.push(valor)
    generarNumeros1a10(valor + 1)
  }
}
    
generarNumeros1a10(1)
console.log(arreglo)`,
        solucion: "[1,2,3,4,5,6,7,8,9,10]"
      }, {
        codigo: 3,
        descripcion: `Como vemos en el ejemplo anterior, la función generarNumeros1a10() se llama a sí misma, generando 10 llamadas recursivas, hasta que el parámetro valor recibe el valor 11 y hace que el if se verifique falso, con lo cual se detienen las llamadas recursivas.
El array que en el ejemplo anterior almacena los números del 1 al 10, se obtiene un resultado diferente si llamamos al método push luego de la llamada recursiva.`,
        programa: `const arreglo = []

function generarNumeros10a1(valor) {
  if (valor <= 10) {
    generarNumeros1a10(valor + 1)
    arreglo.push(valor)
  }
}
    
generarNumeros10a1(1)
console.log(arreglo)`,
        solucion: "[10,9,8,7,6,5,4,3,2,1]"
      }, {
        codigo: 4,
        descripcion: `Un ejemplo clásico de una función recursiva es la función factorial, que calcula el factorial de un número.`,
        programa: `function factorial(numero) {
  if (numero == 0) {
    return 1
  } else {
    return numero * factorial(numero - 1)
  }
}
    
console.log(factorial(5))`,
        solucion: "120"
      }
    ]
  }
  
  export default funcion14;